import React from 'react';
import CTA from "../../../../components/Constant/cta/CTA";
import TimelineSection from "../../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../../components/WhySection/WhySection";
import LocationTimeline from "../../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../../components/IntroSection/IntroSection";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../../components/ServiceCards/ServiceCards";
import SEO from "../../../../utils/SEO";

export default function CryptoVirtualAssetLicenses (){

    return (
        <main className='main'>

            <SEO
                title="Crypto & VASP Licenses | Global Crypto Licensing "
                description="Launch your crypto business with global licensing. Get VASP, DLT, and exchange licenses with full legal and compliance support worldwide. "
                keywords="crypto license services, VASP license, DLT license, crypto exchange license, crypto wallet license, virtual asset regulation, fintech licensing, blockchain compliance "
                url="/crypto-virtual-asset-licenses"
            />

            <IntroSection
                title="Crypto & Virtual Asset Licenses"
                subtitle="Launch Your Crypto Business with Global Licensing Solutions"
                description =
                    "
                        Offshore Advisory helps crypto entrepreneurs, exchanges, and fintech firms obtain Crypto, DLT, and VASP Licenses worldwide. Whether you’re building a crypto exchange, wallet, custodian, token project, or DeFi platform, we provide the legal framework and compliance support you need.                        <br/>
                    "
                badges={
                    [
                        "Crypto Exchange Licenses",
                        "Custody & Wallet Providers ",
                        "DLT & VASP Registration",
                    ]
                }
                buttonText="Request a St. Vincent Brokerage Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../../assets/images/services/forex-brokerage-St-vincent-grenadines-hero.png")}
                imageAlt="Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Do You Need a Crypto License?'
                        subtitle='Running a crypto business without a license limits your growth. With a license, you gain:'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            "title": "Legal Recognition",
                                            "text": "Operate in compliance with regulators."
                                        },
                                        {
                                            "title": "Banking & PSP Access",
                                            "text": "Open crypto-friendly bank and EMI accounts."
                                        },
                                        {
                                            "title": "AML/KYC Compliance",
                                            "text": "Build investor and partner trust."
                                        },
                                        {
                                            "title": "Global Expansion",
                                            "text": "Enter markets that require regulated operators."
                                        },
                                        {
                                            "title": "Token & Exchange Legitimacy",
                                            "text": "List tokens and run ICO/IEO/STO projects."
                                        }
                                    ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Types of Crypto Licenses We Support"
                        item={
                            [
                                {
                                    "title": "Crypto Exchange License",
                                    "text": "Covers CEX and DEX operators."
                                },
                                {
                                    "title": "Custodian & Wallet License",
                                    "text": "Includes hot and cold wallet operations and digital asset custody services."
                                },
                                {
                                    "title": "VASP Registration",
                                    "text": "Virtual Asset Service Provider authorization aligned with FATF standards."
                                },
                                {
                                    "title": "DLT / Blockchain License",
                                    "text": "Allows token issuance, ICO/IEO/STO platforms, and blockchain-based services."
                                },
                                {
                                    "title": "Crypto-Fiat Payment License",
                                    "text": "Enables crypto payment processing and merchant solutions."
                                },
                                {
                                    "title": "DeFi & NFT Marketplaces",
                                    "text": "Jurisdiction-dependent approval for decentralized finance and NFT platforms."
                                }
                            ]
                        }
                    />


                    <InfoBlocks
                        title="Jurisdictions for Crypto & DLT Licenses"
                        blocks={[
                            {
                                title: 'Offshore / Fast Track',
                                items:
                                    [
                                        {
                                            "title": "Western Sahara (CRA)",
                                            "text": "DLT, exchange, and crypto custody licenses."
                                        },
                                        {
                                            "title": "Mwali (Comoros)",
                                            "text": "Crypto exchange and wallet approval."
                                        },
                                        {
                                            "title": "Anjouan (Comoros)",
                                            "text": "Cost-effective, fast-track licensing."
                                        },
                                        {
                                            "title": "Seychelles",
                                            "text": "Crypto exchange frameworks."
                                        }
                                    ]

                            },
                            {
                                title: "Mid-Tier",
                                items:
                                    [
                                        {
                                            "title": "Mauritius",
                                            "text": "Digital Asset and Custodian licenses."
                                        },
                                        {
                                            "title": "Belize",
                                            "text": "Growing recognition for VASP and crypto payment firms."
                                        },
                                        {
                                            "title": "Vanuatu",
                                            "text": "Flexible options for blockchain and token projects."
                                        }
                                    ]
                            },

                            {
                                title: "Recognized / Tier-1",
                                items:
                                    [
                                        {
                                            "title": "Estonia",
                                            "text": "VASP licenses for exchange and custodian services."
                                        },
                                        {
                                            "title": "Malta",
                                            "text": "Virtual Financial Assets (VFA) framework with strong EU credibility."
                                        },
                                        {
                                            "title": "Lithuania",
                                            "text": "Crypto exchange and custodian registration with SEPA access."
                                        },
                                        {
                                            "title": "Gibraltar",
                                            "text": "DLT provider licenses."
                                        },
                                        {
                                            "title": "UAE (ADGM/DIFC)",
                                            "text": "Regulated crypto frameworks for the MENA region."
                                        }
                                    ]
                            },
                        ]}
                    />


                    <ServiceCards
                        title='Our Crypto License Services Include'
                        services={
                            [
                                {
                                    "title": "company-formation",
                                    "text": "Formation of a company in the chosen jurisdiction."
                                },
                                {
                                    "title": "Crypto License Application Preparation",
                                    "text": "Full preparation of documents and requirements for obtaining a crypto license."
                                },
                                {
                                    "title": "AML/KYC Policy Drafting",
                                    "text": "Creation of FATF-compliant AML and KYC policies."
                                },
                                {
                                    "title": "VASP Registration & Reporting Setup",
                                    "text": "Support with VASP registration and establishing regulatory reporting procedures."
                                },
                                {
                                    "title": "Banking & EMI Account Integration",
                                    "text": "Assistance with setting up banking and EMI accounts."
                                },
                                {
                                    "title": "Crypto Exchange White-Label Solutions",
                                    "text": "Deployment of turnkey white-label crypto exchange platforms."
                                },
                                {
                                    "title": "Tokenization & ICO/IEO Structuring",
                                    "text": "Support for tokenization processes and ICO/IEO project structuring."
                                }
                            ]
                        }
                        />

                    {/* Timeline */}
                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Offshore crypto licenses (Western Sahara, Anjouan, Mwali)",
                                duration: "2–8 weeks",
                            },
                            {
                                name: "Mid-tier (Mauritius, Belize, Vanuatu)",
                                description: "2–4 months",
                            },
                            {
                                name: "EU/Tier-1 (Estonia, Malta, Lithuania, Gibraltar)",
                                description: "3–6 months",
                            },
                            {
                                name: "Offshore license",
                                price: "USD 7,000 – 20,000",
                            },
                            {
                                name: "Mid-tier",
                                price: "USD 35,000 – 60,000",
                            },
                            {
                                name: "EU / Tier",
                                price: "USD 75,000 – 150,000+",
                            },
                        ]}
                        end='Costs vary by jurisdiction, license type, and compliance obligations.'
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                { text: "Experts in forex & brokerage structures worldwide." },
                                { text: "Integration with offshore banking, PSPs, and payment providers." },
                                { text: "Assistance with upgrading from SVG to Tier-1 licenses (e.g., Mauritius, Cyprus, Malta)." },
                                { text: "Compliance frameworks for brokers seeking higher credibility." },
                                { text: "Long-term support for scaling & expansion." }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                                Ready to launch your crypto business?
                             "
                         description=
                             "
                                From <b>offshore crypto exchanges</b> to <b>EU-recognized VASP licenses</b>, <b>Offshore Advisory</b> provides <b>turnkey crypto licensing solutions</b>.
                             "
                         buttonText='Book a Crypto License Consultation →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Which crypto license is best for startups?",
        content: [
            { type: "answer", text: "Western Sahara, Anjouan, and Mwali are ideal for quick and cost-efficient setups." },
        ],
    },
    {
        question: "What is a VASP license?",
        content: [
            { type: "answer", text: "A Virtual Asset Service Provider license covers exchange, custody, and transfer of digital assets under FATF guidelines." },
        ],
    },
    {
        question: "Can I operate globally with an offshore crypto license?",
        content: [
            { type: "answer", text: "Yes, but major markets (EU, US, Asia) often require local regulatory approval." },
        ],
    },
    {
        question: "Do I need AML/KYC policies?",
        content: [
            { type: "answer", text: "Yes — regulators mandate compliance policies for all licensed crypto firms." },
        ],
    },
    {
        question: "Can I issue tokens or NFTs under these licenses?",
        content: [
            { type: "answer", text: "Yes, but token issuance may require DLT or securities approval depending on jurisdiction." },
        ],
    },
];


const testimonialsData =
    [
        {
            quote: "Offshore Advisory structured our crypto exchange license in Western Sahara and connected us with PSPs. Highly recommended.",
            author: "Alex P.",
            role: "Exchange Founder"
        },
        {
            quote: "We secured an Estonian VASP license and integrated SEPA accounts thanks to their guidance.",
            author: "Julia R.",
            role: "Blockchain Startup CEO"
        }
    ]
;